import { useEffect, useState } from "react";
import Footer from "../Footer";
import Logos from "../Logos";
import PluginPageHeader from "../PluginPageHeader";

import Plugins from "../Plugins";
import { Container } from "./styles";
import { useAppStore } from "../../stores/appStore";
import AssetImg from "../AssetImg";

function PublicPluginHost({ openLogin }) {
  const [theme, setTheme] = useState("sorbet");
  const [themeType, setThemeType] = useState();

  const user = useAppStore((state) => state.user);

  useEffect(() => {
    // this is a rendering race between the main App component, which is also applying a theme.
    // we want a timeout that is long enough to let the App component render, but not so long that the user sees a flash of the wrong theme.
    setTimeout(() => {
      setTheme(document.body.getAttribute("data-theme"));
      setThemeType(document.body.getAttribute("data-theme-type"));
      document.body.setAttribute("data-theme", "sorbet");
      document.body.setAttribute("data-theme-type", "light");
    }, 10);

    return () => {
      if (theme) {
        document.body.setAttribute("data-theme", theme);
      }
      if (themeType) {
        document.body.setAttribute("data-theme-type", themeType);
      }
    };
  }, []);

  return (
    <Container>
      <PluginPageHeader
        openLogin={openLogin}
      />
      {!user && (
        <div className="sudowrite-explainer">
          <AssetImg
            className="sudowrite-banner"
            src="Wormhole-UI-Sample.png"
            alt="Sudowrite Explainer"
            style={{ alignSelf: "center" }}
          />
          <div className="explainer-content">
            <p className="intro">Welcome Dear Author,</p>
            <p>
              We’re Sudowrite, a company started by authors to put the power of AI in the hands of people like us. We set out to make the writing tool of our dreams. It turns out, it’s something
              thousands of other authors wanted,&nbsp;too!
            </p>
            <p>
              Now we’ve made it so <strong>authors can customize Sudowrite to do incredible new things that help with their writing</strong>. They can even share those creations so other writers can
              benefit. That’s what you’re looking at.
            </p>
            <button onClick={openLogin}>Start a Free Trial</button>
          </div>
        </div>
      )}

      {!user && <Logos />}

      <Plugins openLogin={openLogin} />

      <div className="footer-container">
        <Footer />
      </div>
    </Container>
  );
}

export default PublicPluginHost;
